import Cleave from 'cleave.js';

export default function (element, data) {
    element.cleave = new Cleave(element, {
        prefix: '+7',
        delimiters: [' (', ') ', '-', '-'],
        blocks: [2, 3, 3, 2, 2],
        numericOnly: true,
        noImmediatePrefix: true
    });

    element.addEventListener("blur", function () {
        if (element.value == "+7 (") {
            element.value = "";
        }
    });

    element.form.addEventListener("clear", function () {
        setTimeout(function () {
            element.value = "";
        }, 50);
    });
}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
